import { Attachment } from "airtable"
import ReactMarkdown from "react-markdown"
import tw from "twin.macro"
import { StyledBodyText } from "../bodyText"
import { ExhibitionImage } from "../exhibitions"

interface CardProps {
  body: string
  year: string
  image_url: string
  image_preview: Array<Attachment>
  caption: string
}

const Card = (props: CardProps) => {
  const { body, year, image_url, image_preview, caption } = props
  const bodyText = body ? body.toString() : ""
  const captionText = caption ? caption.toString() : ""

  return (
    <div tw="">
      {image_url && (
        <ExhibitionImage image_url={image_url.toString()} image_preview={image_preview} caption={captionText} />
      )}
      <h3 tw="text-2xl">{year && year.toString()}</h3>
      <StyledBodyText>
        <ReactMarkdown>{bodyText}</ReactMarkdown>
      </StyledBodyText>
    </div>
  )
}

const GroupExhibitions = (props: any) => {
  const { contentData } = props

  return (
    <div tw="max-w-screen-desktop-lg desktop-lg:mx-auto px-4 relative">
      <div tw="grid grid-cols-4 desktop:(grid-cols-12) gap-4 desktop:(gap-6)">
        <div tw="col-span-4 tablet-lg:col-span-8">
          <div tw="space-y-6">
            {contentData.map((item: any, i: number) => {
              return <Card {...item.fields} key={i} />
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default GroupExhibitions
